import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewHistoryV2Response } from './get-review-history-v2-response';
import { getReviewHistoryV2ResponseSchema } from './get-review-history-v2-response';

export interface IGetReviewHistoryV2Request {
  cursor?: string;
}

export async function getReviewHistoryV2Api(
  params?: IGetReviewHistoryV2Request,
): Promise<IValidatedResponse<IGetReviewHistoryV2Response>> {
  return getRequest<IGetReviewHistoryV2Response>({
    path: '/progress/v2/reviews',
    schema: getReviewHistoryV2ResponseSchema,
    options: {
      params: params?.cursor ? { cursor: params.cursor } : undefined,
    },
  });
}
